var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.468 7.262a1.66 1.66 0 0 0-.58-.636l-7.353-4.708a1.655 1.655 0 0 0-1.75 0L2.434 6.62a1.662 1.662 0 0 0-.584.641l7.93 4.932a1.656 1.656 0 0 0 1.76 0l7.928-4.93zm.187 6.567V9.108l-7.236 4.5a3.326 3.326 0 0 1-1.759.505 3.327 3.327 0 0 1-1.759-.506L1.666 9.108v8.885c0 .918.747 1.665 1.665 1.665H17.99c.918 0 1.666-.747 1.666-1.665a.833.833 0 1 1 1.665 0 3.335 3.335 0 0 1-3.331 3.331H3.331A3.335 3.335 0 0 1 0 17.993v-9.97c0-1.142.574-2.19 1.536-2.806L8.892.512a3.31 3.31 0 0 1 3.537 0l7.356 4.71a3.317 3.317 0 0 1 1.535 2.806v5.8a.833.833 0 1 1-1.665 0zM13.95 7.083c0 .46-.373.833-.833.833h-1.666V9.58a.833.833 0 0 1-1.665 0V7.916H8.12a.833.833 0 1 1 0-1.666h1.666V4.584a.833.833 0 1 1 1.665 0V6.25h1.666c.46 0 .833.373.833.833z",
    fill: "#272726",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.fca3ee83fe6baa483ac4ad4be9994c8b.svg";
export { ForwardRef as ReactComponent };